import { createStore } from '../../../../core/utils/stateManagers';

// 뷰 스토어 상태 인터페이스
export interface ViewState {
    selectedViewCode: string;
    currentPage: number;
}

// 초기 상태
const initialState: ViewState = {
    selectedViewCode: 'all',
    currentPage: 1,
};

// 뷰 스토어 생성
export const createViewStore = () => {
    const store = createStore<ViewState>(initialState);

    // URL 파라미터에서 초기 상태 설정
    if (typeof window !== 'undefined') {
        const url = new URL(window.location.href);
        store.update(state => ({
            ...state,
            selectedViewCode: url.searchParams.get('view') || 'all',
            currentPage: parseInt(url.searchParams.get('page') || '1', 10),
        }));
    }

    return {
        ...store,

        // 선택된 뷰 코드 설정
        setSelectedViewCode: (viewCode: string) => store.update(state => ({ ...state, selectedViewCode: viewCode })),

        // 현재 페이지 설정
        setCurrentPage: (page: number) => store.update(state => ({ ...state, currentPage: page })),

        // 스토어 초기화
        reset: () => store.set(initialState),
    };
};

// 싱글톤 인스턴스 생성 및 내보내기
export const searchViewStore = createViewStore();
